import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Opens every new screen at its top: on phones the window scrolls, and the
 * router keeps where the previous screen (the chat, at its end) was. Back and
 * forward are left to the browser.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
